import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { updateNavigationPath } from "../redux/actions/userPref";

/** Restore breadcrumbs when browser history or an in-app Back button is used. DOC*/
export const useNavigationPathHistory = () => {
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();
    const navigationPath = useSelector(state => state.userPref.NavigationPath);
    const lastUpdate = useSelector(state => state.userPref.LastNavigationPathUpdate);
    const paths = useRef(new Map());
    const previousLocation = useRef(location);

    useEffect(() => {
        const locationChanged = previousLocation.current !== location;
        previousLocation.current = location;

        if (locationChanged && history.action === "POP") {
            const savedPath = paths.current.get(location.key);
            const matchingIndex = navigationPath.map(item => item.url).lastIndexOf(location.pathname);
            const restoredPath = (savedPath ?? navigationPath.slice(0, matchingIndex + 1))
                .map(item => ({ ...item }));
            paths.current.set(location.key, restoredPath.map(item => ({ ...item })));
            dispatch(updateNavigationPath(restoredPath));
            localStorage.setItem("navigationPath", JSON.stringify(restoredPath));
            return;
        }

        // Menu actions can update the URL and breadcrumb in separate renders.
        if (
            locationChanged ||
            !paths.current.has(location.key) ||
            navigationPath.length === 0 ||
            navigationPath[navigationPath.length - 1]?.url === location.pathname
        ) {
            paths.current.set(location.key, navigationPath.map(item => ({ ...item })));
        }
    }, [dispatch, history, location, navigationPath, lastUpdate]);
};
